// extracted by mini-css-extract-plugin
export default {"genericInformationWarp":"_12CE5HPcFmVS_bn1AvlFE5","genericInformationText":"_1qH908WoTVbAWHXJFwEGiZ","genericInformationKey":"_30ASX5Esgoc8mp48CI-d3n"};